/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AcademyInputs */

const en_nav_academy = /** @type {(inputs: Nav_AcademyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Academy`)
};

const ja_nav_academy = /** @type {(inputs: Nav_AcademyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカデミー`)
};

const fr_nav_academy = /** @type {(inputs: Nav_AcademyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Académie`)
};

const de_nav_academy = /** @type {(inputs: Nav_AcademyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akademie`)
};

/**
* | output |
* | --- |
* | "Academy" |
*
* @param {Nav_AcademyInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const nav_academy = /** @type {((inputs?: Nav_AcademyInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AcademyInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_academy(inputs)
	if (locale === "ja") return ja_nav_academy(inputs)
	if (locale === "fr") return fr_nav_academy(inputs)
	return de_nav_academy(inputs)
});